import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { SessionStorageService } from '../services';
import { StorageKeys } from '../config';

export const sessionActiveGuard: CanMatchFn = () => {
	const sessionStorageService = inject(SessionStorageService);
	const router = inject(Router);
	const token = sessionStorageService.getItem(StorageKeys.ACCESS_TOKEN);
	return token ? true : router.createUrlTree(['login']);
};
